// Auto-generated by Blender MCP — vertex centroids in web coords [x, z, -y]
// Do not edit manually. Regenerate via the Blender extraction script.

export const SYSTEM_POSITIONS = {
  brain: {
    "Amygdala_L": [0.020862, 1.626847, -0.006559],
    "Amygdala_R": [-0.018604, 1.626847, -0.006559],
    "Anterior commissure": [0.001277, 1.636058, -0.003457],
    "Caudate nucleus_L": [0.016217, 1.651216, -0.015361],
    "Caudate nucleus_R": [-0.01396, 1.651216, -0.015361],
    "Cerebellum_L": [0.013419, 1.598433, -0.041553],
    "Cerebellum_R": [-0.011838, 1.598171, -0.041436],
    "Cerebrum_L": [0.023552, 1.648241, -0.008855],
    "Cerebrum_R": [-0.025264, 1.647598, -0.010145],
    "Cingulate gyrus_L": [0.014165, 1.655563, -0.007299],
    "Cingulate gyrus_R": [-0.011908, 1.655563, -0.007299],
    "Corpus callosum_L": [0.010085, 1.650837, -0.014753],
    "Corpus callosum_R": [-0.007828, 1.650837, -0.014753],
    "Dentate gyrus_L": [0.02068, 1.622204, -0.019117],
    "Dentate gyrus_R": [-0.018422, 1.622204, -0.019117],
    "Fornix_L": [0.012459, 1.63796, -0.014892],
    "Fornix_R": [-0.010201, 1.63796, -0.014892],
    "Fourth ventricle": [0.001282, 1.602002, -0.030172],
    "Globus pallidus lateral_L": [0.020043, 1.644999, -0.013411],
    "Globus pallidus lateral_R": [-0.017786, 1.644999, -0.013411],
    "Globus pallidus medial_L": [0.017171, 1.643535, -0.011743],
    "Globus pallidus medial_R": [-0.014913, 1.643535, -0.011743],
    "Hippocampus_L": [0.024931, 1.625023, -0.02063],
    "Hippocampus_R": [-0.022673, 1.625025, -0.02063],
    "Hypothalamus": [0.001262, 1.637558, -0.006176],
    "Indusium griseum_L": [0.017777, 1.655288, -0.006163],
    "Indusium griseum_R": [-0.015519, 1.655288, -0.006162],
    "Lateral ventricle_L": [0.011589, 1.64258, -0.014659],
    "Lateral ventricle_R": [-0.009331, 1.64258, -0.014659],
    "Medulla oblongata_L": [0.003879, 1.571472, -0.031669],
    "Medulla oblongata_R": [-0.001598, 1.571461, -0.031712],
    "Midbrain_L": [0.011382, 1.633666, -0.007891],
    "Midbrain_R": [-0.009097, 1.633643, -0.007882],
    "Pons_L": [0.005103, 1.604315, -0.022611],
    "Pons_R": [-0.002882, 1.604149, -0.02258],
    "Putamen_L": [0.019588, 1.653886, -0.008952],
    "Putamen_R": [-0.017515, 1.653886, -0.008952],
    "Septal nucleus_L": [0.004304, 1.634291, 0.013548],
    "Septal nucleus_R": [-0.002046, 1.634291, 0.013548],
    "Thalamus_L": [0.008058, 1.641776, -0.013441],
    "Thalamus_R": [-0.005801, 1.641776, -0.013441],
  },
  muscles: {
    "Abductor digiti minimi L": [0.241607, 0.834866, 0.034566],
    "Abductor digiti minimi L_002": [0.120588, 0.023312, -0.016131],
    "Abductor digiti minimi R": [-0.120588, 0.023312, -0.016131],
    "Abductor digiti minimi R_001": [-0.241607, 0.834866, 0.034566],
    "Abductor hallucis L_001": [0.078827, 0.027422, 0.004613],
    "Abductor hallucis R": [-0.078827, 0.027422, 0.004614],
    "Abductor pollicis brevis L": [0.295651, 0.866335, 0.064647],
    "Abductor pollicis brevis R": [-0.295651, 0.866335, 0.064647],
    "Abductor pollicis longus L": [0.250784, 0.982387, -0.011074],
    "Abductor pollicis longus R": [-0.250783, 0.982387, -0.011074],
    "Achilles tendon  L_001": [0.097625, 0.151831, -0.073861],
    "Achilles tendon  R": [-0.097625, 0.151831, -0.073861],
    "Adductor brevis L_001": [0.068416, 0.833023, 0.018627],
    "Adductor brevis R": [-0.068415, 0.833023, 0.018627],
    "Adductor hallucis L_002": [0.093475, 0.026207, 0.043847],
    "Adductor hallucis L_003": [0.104402, 0.016038, 0.064447],
    "Adductor hallucis R": [-0.104402, 0.016038, 0.064447],
    "Adductor hallucis R_001": [-0.093475, 0.026207, 0.043847],
    "Adductor longus L_001": [0.060054, 0.801297, 0.02193],
    "Adductor longus R": [-0.060054, 0.801297, 0.02193],
    "Adductor magnus L": [0.068103, 0.701658, -0.017202],
    "Adductor magnus R": [-0.068104, 0.701658, -0.017202],
    "Adductor pollicis L": [0.292658, 0.844515, 0.05143],
    "Adductor pollicis R": [-0.292658, 0.844515, 0.05143],
    "Anal sphincter external_001": [-0.0, 0.88274, -0.034224],
    "Anal sphincter internal_001": [1.5e-05, 0.877782, -0.0245],
    "Anconeus L": [0.207724, 1.104203, -0.057028],
    "Anconeus R": [-0.207724, 1.104203, -0.057028],
    "Articularis genu L": [0.100914, 0.549356, 0.014281],
    "Articularis genu R": [-0.100914, 0.549356, 0.014282],
    "Auricularis anterior": [0.000583, 1.603907, 0.015542],
    "Auricularis posterior": [0.000553, 1.579763, -0.033006],
    "Auricularis superior": [0.000324, 1.625083, -0.023278],
    "Biceps brachii long head L": [0.167908, 1.310676, -0.02845],
    "Biceps brachii long head R": [-0.167908, 1.310676, -0.02845],
    "Biceps brachii short head L": [0.165121, 1.242454, -0.023404],
    "Biceps brachii short head R": [-0.16512, 1.242454, -0.023404],
    "Biceps femoris short head L_001": [0.125292, 0.559075, -0.019433],
    "Biceps femoris short head R": [-0.125292, 0.559075, -0.019433],
    "Bicipital aponeurosis L": [0.194181, 1.066594, -0.020018],
    "Bicipital aponeurosis R": [-0.194181, 1.066594, -0.020018],
    "Brachialis L": [0.182279, 1.200534, -0.037602],
    "Brachialis R": [-0.182279, 1.200534, -0.037602],
    "Brachioradialis L": [0.234681, 1.049923, -0.009181],
    "Brachioradialis R": [-0.23468, 1.049922, -0.009181],
    "Buccinator": [0.000553, 1.553008, 0.053577],
    "Coccygeuis": [0.0, 0.933771, -0.055038],
    "Common tendinous ring": [0.000553, 1.605251, 0.027379],
    "Coracobrachialis L": [0.138716, 1.352659, -0.042489],
    "Coracobrachialis R": [-0.138716, 1.352659, -0.042489],
    "Corrugator supercilii": [0.000553, 1.63222, 0.074806],
    "Cricothyroid oblique part": [0.000553, 1.493306, -0.000955],
    "Cricothyroid straight part": [0.000553, 1.492904, 0.00384],
    "Deep transverse perineal": [0.0, 0.876301, 0.003114],
    "Deltoid anterior head L": [0.134741, 1.393935, -0.016693],
    "Deltoid anterior head R": [-0.134741, 1.393935, -0.016693],
    "Deltoid middle head L": [0.165345, 1.37651, -0.050046],
    "Deltoid middle head R": [-0.165345, 1.37651, -0.050046],
    "Deltoid posterior head L": [0.131093, 1.382752, -0.085434],
    "Deltoid posterior head L_001": [0.12306, 1.380647, -0.080033],
    "Deltoid posterior head R": [-0.131093, 1.382752, -0.085434],
    "Deltoid posterior head R_001": [-0.12306, 1.380648, -0.080033],
    "Depressor anguli": [0.000553, 1.533579, 0.068026],
    "Depressor labii inferioris": [0.000553, 1.528369, 0.074771],
    "Depressor septi": [-0.000256, 1.572031, 0.087475],
    "Depressor supercilli": [0.000553, 1.626421, 0.079705],
    "Diaphragm": [0.001058, 1.23423, -0.009333],
    "Digastiric": [0.000553, 1.534206, 0.017694],
    "Digastric fibrous loop": [0.000553, 1.525873, 0.019802],
    "Dorsal intereosseous 3rd L": [0.27794, 0.816027, 0.038184],
    "Dorsal intereosseous 3rd R": [-0.27794, 0.816027, 0.038184],
    "Dorsal interossei L_001": [0.106034, 0.0321, 0.056312],
    "Dorsal interossei R": [-0.106034, 0.0321, 0.056312],
    "Dorsal interosseous 1st L": [0.303856, 0.842783, 0.050953],
    "Dorsal interosseous 1st R": [-0.303856, 0.842783, 0.050953],
    "Dorsal interosseous 2nd L": [0.292372, 0.825791, 0.043354],
    "Dorsal interosseous 2nd R": [-0.292372, 0.825791, 0.043354],
    "Dorsal interosseous 4th L": [0.258903, 0.815726, 0.035464],
    "Dorsal interosseous 4th R": [-0.258903, 0.815726, 0.035464],
    "Extensor Hallucis longus L_001": [0.098427, 0.150318, 0.00651],
    "Extensor Hallucis longus R": [-0.098427, 0.150318, 0.00651],
    "Extensor carpi radialis brevis L": [0.253837, 0.997612, -0.011237],
    "Extensor carpi radialis brevis R": [-0.253836, 0.997612, -0.011237],
    "Extensor carpi radialis longus L": [0.251627, 1.006703, -0.007302],
    "Extensor carpi radialis longus R": [-0.251628, 1.006703, -0.007302],
    "Extensor carpi ulnaris L": [0.224191, 0.987618, -0.02399],
    "Extensor carpi ulnaris R": [-0.224191, 0.987618, -0.02399],
    "Extensor digiti minimi L": [0.237748, 0.882172, 0.007901],
    "Extensor digiti minimi R": [-0.237749, 0.882172, 0.007901],
    "Extensor digitorum L": [0.26879, 0.847268, 0.027197],
    "Extensor digitorum R": [-0.268759, 0.847268, 0.027258],
    "Extensor digitorum brevis L": [0.110373, 0.043092, 0.03896],
    "Extensor digitorum brevis R": [-0.110373, 0.043092, 0.03896],
    "Extensor digitorum longus L_001": [0.112187, 0.125702, 0.019182],
    "Extensor digitorum longus R": [-0.112244, 0.125547, 0.019172],
    "Extensor hallucis brevis L": [0.091259, 0.049659, 0.032912],
    "Extensor hallucis brevis R": [-0.091259, 0.049659, 0.032912],
    "Extensor indicis L": [0.280377, 0.867247, 0.026607],
    "Extensor indicis R": [-0.280377, 0.867247, 0.026607],
    "Extensor pollicis brevis L": [0.271157, 0.93081, 0.010988],
    "Extensor pollicis brevis R": [-0.271157, 0.93081, 0.010988],
    "Extensor pollicis longus L": [0.274762, 0.910011, 0.017772],
    "Extensor pollicis longus R": [-0.274762, 0.910011, 0.017772],
    "External intercostal": [0.0, 1.318452, -0.032778],
    "External oblique": [-0.0, 1.128445, 0.036905],
    "Fibularis brevis L": [0.118912, 0.131705, -0.036655],
    "Fibularis brevis R": [-0.118879, 0.131705, -0.03685],
    "Fibularis longus L_001": [0.119608, 0.180653, -0.025775],
    "Fibularis longus R": [-0.119797, 0.180653, -0.025931],
    "Fibularis tertius L_001": [0.115854, 0.106472, -0.021089],
    "Fibularis tertius R": [-0.116381, 0.106472, -0.021338],
    "Flexor Carpi ulnaris L": [0.207141, 1.003855, -0.020356],
    "Flexor Carpi ulnaris R": [-0.207142, 1.003855, -0.020356],
    "Flexor Hallucis longus L_001": [0.098198, 0.119377, -0.02069],
    "Flexor Hallucis longus R": [-0.098199, 0.119377, -0.02069],
    "Flexor carpi radialis L": [0.23891, 0.968802, 0.009517],
    "Flexor carpi radialis R": [-0.23891, 0.968802, 0.009517],
    "Flexor digiti minimi brevis L": [0.24744, 0.834164, 0.041337],
    "Flexor digiti minimi brevis L_002": [0.121521, 0.024378, 0.034085],
    "Flexor digiti minimi brevis R": [-0.24744, 0.834164, 0.041337],
    "Flexor digiti minimi brevis R_001": [-0.121521, 0.024378, 0.034085],
    "Flexor digitorum L": [0.092726, 0.115604, -0.002943],
    "Flexor digitorum R": [-0.092726, 0.115604, -0.002943],
    "Flexor digitorum brevis L": [0.10594, 0.01652, 0.024549],
    "Flexor digitorum brevis R": [-0.10594, 0.01652, 0.024549],
    "Flexor digitorum profundus L": [0.243758, 0.91387, 0.0151],
    "Flexor digitorum profundus R": [-0.243758, 0.91387, 0.0151],
    "Flexor digitorum superficialis L": [0.241127, 0.922962, 0.016587],
    "Flexor digitorum superficialis R": [-0.241125, 0.922966, 0.016585],
    "Flexor hallucis brevis L_001": [0.085611, 0.025194, 0.039141],
    "Flexor hallucis brevis R": [-0.085611, 0.025194, 0.039141],
    "Flexor pollicis brevis L": [0.293536, 0.861479, 0.058992],
    "Flexor pollicis brevis R": [-0.293536, 0.861479, 0.058992],
    "Flexor pollicis longus L": [0.262811, 0.931998, 0.024005],
    "Flexor pollicis longus R": [-0.262811, 0.931998, 0.024005],
    "Gastrocnemius L_001": [0.092008, 0.405177, -0.058668],
    "Gastrocnemius R": [-0.092008, 0.405178, -0.058668],
    "Genioglossus": [0.000553, 1.530362, 0.051476],
    "Geniohyoid": [0.000553, 1.520952, 0.04859],
    "Gluteus maximus L": [0.098641, 0.938017, -0.052067],
    "Gluteus maximus R": [-0.098641, 0.938017, -0.052067],
    "Gluteus medius L": [0.113409, 0.997616, -0.026582],
    "Gluteus medius R": [-0.113408, 0.997616, -0.026582],
    "Gluteus minimus L": [0.122155, 0.971413, -0.001422],
    "Gluteus minimus R": [-0.122155, 0.971413, -0.001422],
    "Gracilis L": [0.040431, 0.645163, -0.013463],
    "Gracilis R": [-0.04043, 0.645163, -0.013462],
    "Greater omentum": [0.006249, 1.116089, 0.069718],
    "Hyoglossus": [0.000553, 1.535055, 0.025461],
    "Iliacus_001": [0.0, 0.970044, 0.013246],
    "Iliocostalis lumborum_001": [-0.0, 1.179488, -0.074171],
    "Illiococcygeus_001": [-0.0, 0.898746, -0.016951],
    "Illiocostalis cervicis": [0.000552, 1.425818, -0.066172],
    "Illiocostalis thoracis_001": [0.000553, 1.34822, -0.075623],
    "Inferior gemellus L_001": [0.099211, 0.903198, -0.022276],
    "Inferior gemellus R": [-0.099211, 0.903198, -0.022276],
    "Inferior oblique": [0.000553, 1.602401, 0.060931],
    "Inferior rectus": [0.000553, 1.601375, 0.049843],
    "Infraspinatus L": [0.109762, 1.390013, -0.084169],
    "Infraspinatus R": [-0.109762, 1.390013, -0.084169],
    "Interansversarii posteriores cervicis": [0.000553, 1.509374, -0.031686],
    "Internal intercostal": [-0.0, 1.310444, -0.007473],
    "Internal oblique_001": [-0.0, 1.091179, 0.018217],
    "Interspinales cervicis": [0.000568, 1.505827, -0.05996],
    "Intertransversarii anteriores cervicis": [0.000553, 1.505678, -0.026207],
    "Intertransversarii mediales lumborum": [0.0, 1.273741, -0.07163],
    "Intertransversii laterales lumborum": [0.0, 1.123589, -0.036427],
    "Lateral pterygoid": [0.000553, 1.590442, 0.023188],
    "Lateral pterygoid_001": [0.000553, 1.579909, 0.01774],
    "Lateral rectus": [0.000553, 1.60877, 0.047286],
    "Latissimus dorsi L": [0.064317, 1.18735, -0.074021],
    "Latissimus dorsi R": [-0.064318, 1.18735, -0.074021],
    "Lesser omentum": [-0.005656, 1.21171, 0.024175],
    "Levator anguli oris": [0.000553, 1.570915, 0.07089],
    "Levator labii superioris": [0.000553, 1.577715, 0.077029],
    "Levator labii superioris alaeque nasi": [0.000306, 1.588642, 0.082181],
    "Levator palpebrae superioris": [0.000553, 1.617836, 0.04868],
    "Levatores costarum": [-0.0, 1.341761, -0.083135],
    "Levatores costarum breves": [-0.0, 1.34643, -0.081214],
    "Ligament Treitz": [0.01653, 1.197363, 0.003268],
    "Longissimus capitis": [0.000553, 1.499135, -0.046765],
    "Longissimus cervicis": [0.000553, 1.433141, -0.074266],
    "Longissimus thoracis": [-0.0, 1.265681, -0.078764],
    "Longus capitis": [0.000553, 1.528781, -0.015056],
    "Longus colli": [0.000526, 1.528879, -0.01494],
    "Longus colli 02": [0.000553, 1.454586, -0.038156],
    "Longus colli_001": [0.000553, 1.478694, -0.027566],
    "Lumbrical 1st L": [0.299659, 0.837416, 0.055547],
    "Lumbrical 1st R": [-0.299659, 0.837416, 0.055547],
    "Lumbrical 2nd L": [0.284197, 0.828448, 0.046788],
    "Lumbrical 2nd R": [-0.284197, 0.828449, 0.046788],
    "Lumbrical 3rd L": [0.270386, 0.828107, 0.043853],
    "Lumbrical 3rd R": [-0.270386, 0.828107, 0.043853],
    "Lumbrical 4th L": [0.255369, 0.821843, 0.041156],
    "Lumbrical 4th R": [-0.255369, 0.821843, 0.041156],
    "Lumbricals L_001": [0.104385, 0.018894, 0.04949],
    "Lumbricals R": [-0.104385, 0.018894, 0.04949],
    "Masseter deep": [0.000553, 1.575166, 0.021295],
    "Masseter superficial": [0.000553, 1.565598, 0.036109],
    "Medial pterygoid": [0.000553, 1.566415, 0.026482],
    "Medial rectus": [0.000553, 1.609267, 0.049513],
    "Mentalis": [0.000553, 1.526494, 0.07931],
    "Mesh_11263_Retopo_Retopo  L": [0.041999, 0.006816, -0.001634],
    "Multifidus": [0.000553, 1.454888, -0.070123],
    "Multifidus_001": [-1e-06, 1.208161, -0.075028],
    "Mylohyoid": [0.000553, 1.523413, 0.047226],
    "Nasalis alarportion": [0.000553, 1.576063, 0.083659],
    "Nasalis transverse portion": [5.3e-05, 1.588802, 0.082905],
    "Obliqyys capitis superior": [0.000553, 1.563845, -0.044157],
    "Obturator externus L_001": [0.077306, 0.900973, 0.009005],
    "Obturator externus R": [-0.077306, 0.900973, 0.009005],
    "Obturator internus L": [0.063661, 0.920235, -0.00167],
    "Obturator internus R": [-0.063661, 0.920235, -0.00167],
    "Occipitofrontalis epicranius": [0.000553, 1.653401, -0.018032],
    "Omohyoid": [0.000553, 1.46639, -0.014603],
    "Opponens digiti minimi L": [0.119837, 0.027754, 0.019199],
    "Opponens digiti minimi L_001": [0.246769, 0.843485, 0.034938],
    "Opponens digiti minimi R": [-0.119837, 0.027754, 0.019199],
    "Opponens digiti minimi R_001": [-0.246768, 0.843485, 0.034938],
    "Opponens pollicis L": [0.295626, 0.871041, 0.057636],
    "Opponens pollicis R": [-0.295626, 0.871041, 0.057636],
    "Orbicularis oculi": [-0.000703, 1.610427, 0.06909],
    "Orbicularis oris": [-0.000199, 1.551177, 0.080692],
    "Palatoglossus": [0.000553, 1.552499, 0.040038],
    "Palmar interosseous 1st L": [0.295818, 0.827548, 0.04822],
    "Palmar interosseous 1st R": [-0.295817, 0.827548, 0.04822],
    "Palmar interosseous 2nd L": [0.270647, 0.819678, 0.039987],
    "Palmar interosseous 2nd R": [-0.270647, 0.819678, 0.039987],
    "Palmar interosseous 3rd L": [0.252396, 0.820107, 0.03662],
    "Palmar interosseous 3rd R": [-0.252396, 0.820107, 0.03662],
    "Palmaris brevis L": [0.244543, 0.851833, 0.041146],
    "Palmaris brevis R": [-0.244543, 0.851833, 0.041146],
    "Palmaris longus L": [0.214495, 0.996057, -0.001664],
    "Palmaris longus R": [-0.214495, 0.996057, -0.001664],
    "Pectineus L_001": [0.070929, 0.88608, 0.032183],
    "Pectineus R": [-0.070929, 0.88608, 0.032183],
    "Pectoralis major L": [0.087778, 1.345121, 0.031894],
    "Pectoralis major R": [-0.087778, 1.345121, 0.031894],
    "Pectoralis miinor L": [0.090756, 1.367512, 0.022768],
    "Pectoralis miinor R": [-0.090756, 1.367512, 0.022768],
    "Piriformis L_001": [0.075787, 0.960409, -0.036699],
    "Piriformis R": [-0.075787, 0.960409, -0.036699],
    "Plantar interossei L_001": [0.111069, 0.029207, 0.049681],
    "Plantar interossei R": [-0.111069, 0.029207, 0.049681],
    "Plantaris L": [0.091906, 0.307163, -0.056373],
    "Plantaris R": [-0.091906, 0.307163, -0.056373],
    "Platysma": [7.4e-05, 1.504174, 0.03199],
    "Popliteus L_001": [0.111422, 0.43235, -0.034537],
    "Popliteus R": [-0.111421, 0.43235, -0.034537],
    "Posterior cricoarytenoid": [0.000553, 1.497873, -0.00613],
    "Procerus": [0.000553, 1.623808, 0.081745],
    "Pronator quadratus L": [0.251627, 0.910993, 0.0161],
    "Pronator quadratus R": [-0.251627, 0.910993, 0.0161],
    "Pronator teres L": [0.207268, 1.082146, -0.022629],
    "Pronator teres R": [-0.207268, 1.082146, -0.022629],
    "Psoas major _001": [-0.0, 1.042347, -0.00588],
    "Psoas minor": [0.0, 1.078083, -0.011335],
    "Pubococccygeus": [-1.1e-05, 0.901893, -0.023985],
    "Pyramidalis_001": [0.0, 0.951655, 0.06304],
    "Quadratus femoris L": [0.1063, 0.890471, -0.015077],
    "Quadratus femoris R": [-0.1063, 0.890471, -0.015077],
    "Quadratus lumborum_001": [0.0, 1.134325, -0.044804],
    "Quadratus plantea L": [0.102323, 0.025878, -0.029965],
    "Quadratus plantea R": [-0.102323, 0.025878, -0.029964],
    "Rectus abodominis": [0.0, 1.14745, 0.079588],
    "Rectus capitis anterior": [0.000553, 1.558465, -0.019883],
    "Rectus capitis lateralis": [0.000553, 1.541076, -0.042072],
    "Rectus capitis lateralis_001": [0.000553, 1.559519, -0.027991],
    "Rectus capitis posterior major": [0.000553, 1.554044, -0.056118],
    "Rectus capitis posterior minor": [0.000553, 1.564227, -0.059901],
    "Rectus femoris L_001": [0.105152, 0.732511, 0.04463],
    "Rectus femoris R": [-0.105151, 0.732511, 0.04463],
    "Rhomboideus major": [0.000553, 1.393074, -0.100348],
    "Rhomboideus minor": [0.000553, 1.437973, -0.088168],
    "Risorius": [0.000553, 1.554033, 0.060824],
    "Rotatores thoracis breves": [0.0, 1.357571, -0.081392],
    "Rotatores thoracis longi": [-0.0, 1.352395, -0.08387],
    "Sartorius L": [0.064899, 0.676078, 0.011545],
    "Sartorius R": [-0.064902, 0.676078, 0.011545],
    "Scalene anterior": [0.000553, 1.467433, -0.019604],
    "Scalene middle": [0.000553, 1.476143, -0.032127],
    "Scalene posterior": [0.000553, 1.454806, -0.041359],
    "Semimembranosus L": [0.072921, 0.665417, -0.042053],
    "Semimembranosus R": [-0.072921, 0.665417, -0.042053],
    "Semispinalis capitis": [0.000553, 1.511075, -0.068608],
    "Semispinalis capitis_001": [0.000553, 1.540055, -0.052181],
    "Semispinalis cervicis": [0.000553, 1.456146, -0.073911],
    "Semispinalis thoracis": [0.000553, 1.361982, -0.091965],
    "Semitendinosus L": [0.112566, 0.661579, -0.03723],
    "Semitendinosus L_003": [0.074999, 0.627622, -0.049909],
    "Semitendinosus R": [-0.112565, 0.661579, -0.03723],
    "Semitendinosus R_001": [-0.075, 0.627622, -0.049909],
    "Serratus anterior L": [0.096046, 1.343864, -0.046927],
    "Serratus anterior R": [-0.096046, 1.343864, -0.046927],
    "Serratus posterior inferior": [0.0, 1.20156, -0.076219],
    "Serratus posterior superior": [0.000553, 1.422321, -0.079954],
    "Soleus L_001": [0.103137, 0.242132, -0.057271],
    "Soleus R": [-0.103137, 0.242132, -0.057271],
    "Spinalis cervicis": [0.000553, 1.480721, -0.066281],
    "Spinalis thoracis": [0.0, 1.272712, -0.090763],
    "Spinalis thoracis_001": [0.000553, 1.456898, -0.071976],
    "Splenius capitis": [0.000552, 1.500637, -0.065677],
    "Splenius cervicis": [0.000553, 1.446787, -0.074094],
    "Sternalis": [-0.0, 1.351906, 0.063908],
    "Sternocleidomastoid": [0.000553, 1.505745, -0.015314],
    "Sternohyoid": [0.000553, 1.462637, 0.015599],
    "Sternothyroid": [0.000553, 1.450852, 0.007681],
    "Styloglossus": [0.000553, 1.545455, 0.028273],
    "Stylohyoid": [0.000553, 1.542648, 0.0074],
    "Subclavius L": [0.073104, 1.427736, -0.007043],
    "Subclavius R": [-0.073104, 1.427736, -0.007043],
    "Subcostal": [0.0, 1.286415, -0.074612],
    "Subscapularis L": [0.107365, 1.391559, -0.061532],
    "Subscapularis R": [-0.107365, 1.391558, -0.061532],
    "Superficial transverse perineal_001": [0.0, 0.867917, -0.01979],
    "Superior gemellus L": [0.096232, 0.928098, -0.025193],
    "Superior gemellus R": [-0.096232, 0.928098, -0.025193],
    "Superior oblique": [0.000553, 1.618196, 0.051871],
    "Supinator L": [0.226617, 1.080374, -0.032781],
    "Supinator R": [-0.226616, 1.080374, -0.032781],
    "Supraspinatus L": [0.106181, 1.425745, -0.067087],
    "Supraspinatus R": [-0.106181, 1.425745, -0.067087],
    "Temporal fascia": [0.000553, 1.633271, 0.008257],
    "Temporalis": [0.000553, 1.626949, 0.011925],
    "Tensor fascia lata L_001": [0.147864, 0.727954, 0.018197],
    "Tensor fascia lata R": [-0.147862, 0.727954, 0.018197],
    "Thyrohyoid": [0.000553, 1.513411, 0.012465],
    "Tibialis anterior L": [0.098481, 0.217994, -0.008285],
    "Tibialis anterior R": [-0.098482, 0.217994, -0.008285],
    "Tibialis posterior L": [0.094478, 0.182499, -0.029086],
    "Tibialis posterior R": [-0.094479, 0.182499, -0.029086],
    "Transversus abdominis": [-0.0, 1.113856, 0.039436],
    "Transversus thoracis": [0.0, 1.303986, 0.066933],
    "Trapezius": [0.000553, 1.445008, -0.078998],
    "Tres major L": [0.118051, 1.355232, -0.077159],
    "Tres major R": [-0.118051, 1.355232, -0.077159],
    "Triceps L": [0.17394, 1.229603, -0.057488],
    "Triceps R": [-0.173939, 1.229603, -0.057487],
    "Triceps lateral head L": [0.178869, 1.285744, -0.066232],
    "Triceps lateral head R": [-0.17887, 1.285744, -0.066232],
    "Triceps long head L": [0.151407, 1.288737, -0.067625],
    "Triceps long head R": [-0.151407, 1.288737, -0.067625],
    "Triceps tendon L": [0.189264, 1.169764, -0.072488],
    "Triceps tendon R": [-0.189264, 1.169764, -0.072488],
    "Vastus Lateralis L": [0.1363, 0.715883, 0.019594],
    "Vastus Lateralis R": [-0.136299, 0.715883, 0.019594],
    "Vastus intermedius L": [0.109072, 0.691407, 0.027151],
    "Vastus intermedius R": [-0.109071, 0.691407, 0.027151],
    "Vastus medialis L_001": [0.082863, 0.693798, 0.019594],
    "Vastus medialis R": [-0.082863, 0.693798, 0.019594],
    "Zygomaticus major": [0.000553, 1.573087, 0.059852],
    "Zygomaticus minor": [0.000553, 1.576869, 0.071458],
    "sp": [0.000553, 1.475803, -0.049068],
    "superior rectus": [0.000553, 1.617414, 0.048149],
  },
  cardiovascularsystem: {
    "Abdomen_aorta_abdominalis_arteries": [0.006307, 1.174331, 0.000266],
    "Aortaa": [0.009833, 1.343338, 0.003512],
    "Aortic_arteries": [0.006151, 1.405642, -0.02378],
    "Aortic_valve": [0.014531, 1.331454, 0.002647],
    "Back_Heart": [0.022025, 1.299591, 0.013526],
    "Capslice_Type2": [0.025882, 1.313707, 0.021342],
    "Cardiac": [0.019258, 1.244981, -0.003072],
    "Gut_Veins": [0.010843, 1.133538, 0.017234],
    "Gut_arteries": [0.011968, 1.135374, 0.016879],
    "Head_neck001_Veins": [0.001053, 1.601701, 0.029812],
    "Head_neck_arteries": [-0.000371, 1.613781, 0.009888],
    "Kidney__Veins_L_001": [0.042992, 1.182127, -0.014122],
    "Kidney__Veins_R": [-0.051434, 1.182419, -0.011411],
    "Kidney__arteries_L": [0.04307, 1.182375, -0.012379],
    "Kidney__arteries_R_001": [-0.053073, 1.182081, -0.010554],
    "Liver_Veins": [-0.027977, 1.237726, 0.025875],
    "Liver_arteries": [-0.038254, 1.226446, 0.024376],
    "Lower_limb_Veins_L": [0.098725, 0.255077, 0.024557],
    "Lower_limb_Veins_R": [-0.096855, 0.254263, 0.024556],
    "Lower_limb_arteries_L_001": [0.100768, 0.282072, 0.020503],
    "Lower_limb_arteries_R": [-0.100744, 0.282043, 0.020494],
    "Mitral_valve": [0.024431, 1.311686, -0.009778],
    "Pelvis_Veins_001": [-0.001554, 0.993016, 0.005522],
    "Pelvis_arteries": [0.0037, 0.966396, -0.007594],
    "Pulmonary_Veins_L_001": [0.064756, 1.333854, -0.005494],
    "Pulmonary_Veins_R": [-0.057794, 1.340507, -0.012851],
    "Pulmonary_inferior___arteries_L": [0.071221, 1.305854, -0.023829],
    "Pulmonary_inferior_arteries_R": [-0.067318, 1.309554, -0.028541],
    "Pulmonary_superior_arteries_L_001": [0.061487, 1.350523, 0.003983],
    "Pulmonary_superior_arteries_R": [-0.052531, 1.355568, -0.000759],
    "Pulmonary_valve": [0.025333, 1.344525, 0.016937],
    "Pulmonary_vein_": [0.000808, 1.324229, -0.007721],
    "Pulmoneryartery": [0.009354, 1.349592, -0.013232],
    "Superior_vena_cava_Veins": [-0.002252, 1.456653, 0.00621],
    "Tricuspic_valve": [0.004915, 1.307164, 0.014681],
    "Upper_limb_Veins_L": [0.212556, 1.053136, 0.017226],
    "Upper_limb_Veins_R": [-0.211689, 1.050125, 0.017296],
    "Upper_limb_arteries_L": [0.211012, 1.05182, 0.008572],
    "Upper_limb_arteries_R": [-0.21176, 1.051498, 0.008711],
    "abdomen_inferior_vena_cavav_Veins": [-0.009043, 1.202911, 0.005606],
    "thorax_Veins": [0.001429, 1.285139, -0.012425],
    "thorax_arteries_001": [-0.001054, 1.292872, -0.02273],
  },
  nervoussystem: {
    "Amygdala_L": [0.020862, 1.626846, -0.006559],
    "Amygdala_R": [-0.018604, 1.626846, -0.006559],
    "Anterior commissure": [0.001277, 1.636058, -0.003457],
    "Brachial_Plexus_Roots_C5-T1_L": [-0.014168, 1.358274, -0.04535],
    "Brachial_Plexus_Roots_C5-T1_R": [0.016981, 1.358301, -0.045375],
    "Brain membrane": [0.001251, 1.626968, -0.010066],
    "Caudate nucleus_L": [0.016217, 1.651215, -0.015361],
    "Caudate nucleus_R": [-0.01396, 1.651216, -0.015361],
    "Cerebellum_L": [0.013419, 1.598433, -0.041553],
    "Cerebellum_R": [-0.011838, 1.598171, -0.041436],
    "Cerebrum_L": [0.023552, 1.648241, -0.008855],
    "Cerebrum_R": [-0.025264, 1.647598, -0.010145],
    "Cervical_Plexus_C1-C4_L": [-0.021642, 1.486155, -0.030445],
    "Cervical_Plexus_C1-C4_R": [0.022534, 1.485458, -0.031531],
    "Cingulate gyrus_L": [0.014165, 1.655563, -0.007299],
    "Cingulate gyrus_R": [-0.011908, 1.655563, -0.007299],
    "Corpus callosum_L": [0.010085, 1.650837, -0.014753],
    "Corpus callosum_R": [-0.007828, 1.650836, -0.014753],
    "Cranial_Nerves_CN_III-VIII_L": [-0.034883, 1.613857, 0.018182],
    "Cranial_Nerves_CN_III-VIII_R": [0.034108, 1.613858, 0.01817],
    "Deep_Peroneal_Nerve_L4-S1_L": [-0.07662, 0.191381, -0.026387],
    "Deep_Peroneal_Nerve_L4-S1_R": [0.076555, 0.191376, -0.026324],
    "Dentate gyrus_L": [0.02068, 1.622204, -0.019117],
    "Dentate gyrus_R": [-0.018422, 1.622204, -0.019117],
    "Femoral_Nerve_L2-L4_L": [-0.108007, 0.945208, -0.057215],
    "Femoral_Nerve_L2-L4_R": [0.108012, 0.945193, -0.057304],
    "Fornix_L": [0.012459, 1.63796, -0.014892],
    "Fornix_R": [-0.010201, 1.63796, -0.014892],
    "Fourth ventricle": [0.001282, 1.602002, -0.030172],
    "Genitofemoral_Nerve_L1-L2_L": [-0.10387, 0.912126, 0.057312],
    "Genitofemoral_Nerve_L1-L2_R": [0.103855, 0.912139, 0.057261],
    "Globus pallidus lateral_L": [0.020043, 1.644999, -0.013411],
    "Globus pallidus lateral_R": [-0.017786, 1.644999, -0.013411],
    "Globus pallidus medial_L": [0.017171, 1.643535, -0.011743],
    "Globus pallidus medial_R": [-0.014913, 1.643535, -0.011743],
    "Hippocampus_L": [0.024931, 1.625023, -0.02063],
    "Hippocampus_R": [-0.022673, 1.625025, -0.02063],
    "Hypothalamus": [0.001262, 1.637558, -0.006176],
    "Iliohypogastric_Nerve_L1_L": [-0.176363, 1.027941, -0.006464],
    "Iliohypogastric_Nerve_L1_R": [0.17614, 1.028414, -0.006597],
    "Ilioinguinal_Nerve_L1_L": [-0.032536, 1.033023, -0.032384],
    "Ilioinguinal_Nerve_L1_R": [0.034681, 1.033038, -0.032405],
    "Indusium griseum_L": [0.017777, 1.655288, -0.006163],
    "Indusium griseum_R": [-0.015519, 1.655288, -0.006162],
    "Intercostal_Nerves_T1-T8_L": [-0.055178, 1.226404, -0.027742],
    "Intercostal_Nerves_T1-T8_R": [0.057013, 1.226393, -0.027762],
    "Lateral ventricle_L": [0.011589, 1.64258, -0.014659],
    "Lateral ventricle_R": [-0.009331, 1.64258, -0.014659],
    "Lateral_Cutaneous_Nerve_of_Thigh_L2-L3_L": [-0.283767, 0.852914, 0.047591],
    "Lateral_Cutaneous_Nerve_of_Thigh_L2-L3_R": [0.283736, 0.85292, 0.047622],
    "Median_Nerve_L": [-0.102676, 1.360566, -0.042853],
    "Median_Nerve_R": [0.102664, 1.360559, -0.042854],
    "Medulla oblongata_L": [0.003879, 1.571471, -0.031669],
    "Medulla oblongata_R": [-0.001598, 1.571461, -0.031712],
    "Midbrain_L": [0.011382, 1.633666, -0.007891],
    "Midbrain_R": [-0.009097, 1.633643, -0.007882],
    "Musculocutaneous_Nerve_L": [-0.149721, 1.342316, -0.039118],
    "Musculocutaneous_Nerve_R": [0.149724, 1.342316, -0.039124],
    "Obturator_Nerve_L2-L4_L": [-0.040702, 0.894966, -0.008457],
    "Obturator_Nerve_L2-L4_R": [0.040997, 0.894968, -0.00849],
    "Pons_L": [0.005093, 1.604288, -0.022598],
    "Pons_R": [-0.002887, 1.60413, -0.022584],
    "Pudendal_Nerve_S2-S4_L": [-0.075137, 0.564925, -0.006409],
    "Pudendal_Nerve_S2-S4_R": [0.075171, 0.564925, -0.006389],
    "Putamen_L": [0.019588, 1.653886, -0.008952],
    "Putamen_R": [-0.017515, 1.653886, -0.008952],
    "Saphenous_Nerve_L3-L4_L": [-0.2437, 0.791343, 0.035347],
    "Saphenous_Nerve_L3-L4_R": [0.243702, 0.791358, 0.035407],
    "Sciatic_Nerve_L4-S3_L": [-0.136718, 0.742502, -0.032524],
    "Sciatic_Nerve_L4-S3_R": [0.136651, 0.742491, -0.032602],
    "Septal nucleus_L": [0.004304, 1.634291, 0.013548],
    "Septal nucleus_R": [-0.002046, 1.634291, 0.013548],
    "Spinal cord membrane": [0.000966, 1.340313, -0.052464],
    "Spinal cords": [0.000973, 1.290802, -0.043507],
    "Subcostal_and_Lower_Intercostal_T9-T12_L": [-0.049293, 1.137444, -0.008458],
    "Subcostal_and_Lower_Intercostal_T9-T12_R": [0.051117, 1.137556, -0.008411],
    "Superficial_Peroneal_Nerve_L4-S1_L": [-0.106105, 0.022541, 0.06378],
    "Superficial_Peroneal_Nerve_L4-S1_R": [0.106068, 0.022571, 0.063792],
    "Sural_Nerve_S1-S2_L": [-0.103355, 0.176359, 0.023199],
    "Sural_Nerve_S1-S2_R": [0.103338, 0.176382, 0.023199],
    "Thalamus_L": [0.008058, 1.641776, -0.013441],
    "Thalamus_R": [-0.005801, 1.641776, -0.013441],
    "Tibial_Nerve_L4-S3_L": [-0.100842, 0.269529, -0.041081],
    "Tibial_Nerve_L4-S3_R": [0.100799, 0.269525, -0.041045],
    "Ulnar_Nerve_L": [-0.074044, 1.343098, 0.026523],
    "Ulnar_Nerve_R": [0.074153, 1.343075, 0.026467],
    "Vagus_Nerve_CN_X_L": [-0.025357, 1.565909, -0.008118],
    "Vagus_Nerve_CN_X_R": [0.025255, 1.564353, -0.004919],
    "olfactory bulb": [0.00929, 1.618184, 0.022773],
    "olfactory bulb_001": [-0.007492, 1.61818, 0.022516],
    "olfactory nerves": [0.003338, 1.614362, 0.049989],
    "olfactory nerves_001": [-0.00149, 1.614362, 0.049989],
  },
  lymphaticsystem: {
    "Lymph nodes L": [0.041516, 1.307154, -0.00051],
    "Lymph nodes R": [-0.040939, 1.30714, -0.000494],
    "Lymph nodes02": [0.013402, 1.157311, 0.014062],
    "Lymph vessel L": [0.066691, 1.150696, 0.011557],
    "Lymph vessel R": [-0.06713, 1.150324, 0.011554],
    "Spleen": [0.073617, 1.227548, -0.023304],
    "Thymus": [0.016606, 1.212061, 0.009455],
    "Thymus_001": [0.00026, 1.369943, 0.008015],
    "Thyroid": [0.000508, 1.498936, 0.01491],
  },
  digestivesystem: {
    "Anal_sphincter_external_001": [-0.0, 0.882741, -0.034224],
    "Anal_sphincter_internal_001": [1.5e-05, 0.877782, -0.0245],
    "Ducts_A": [0.026755, 1.196128, 0.008065],
    "Ducts_B": [-0.010844, 1.168427, 0.025265],
    "Duodenum": [-0.010389, 1.156911, 0.026433],
    "Esophagus_": [0.002405, 1.38357, -0.030443],
    "Gall_bladder": [-0.016513, 1.214267, 0.042855],
    "Genioglossus": [0.000553, 1.530152, 0.051658],
    "Geniohyoid": [0.000553, 1.520952, 0.04859],
    "Gingiva": [0.0, 1.549469, 0.066343],
    "Greater_omentum": [0.006249, 1.116088, 0.069718],
    "Hyoglossus": [0.000553, 1.535055, 0.025461],
    "Large_Intestine": [0.008023, 1.078306, 0.015026],
    "Left_Lobe": [0.02647, 1.250165, 0.045534],
    "Lesser_omentum": [-0.005656, 1.21171, 0.024174],
    "Ligament_Treitz": [0.01653, 1.197363, 0.003269],
    "Liver_Veins": [-0.027977, 1.237725, 0.025875],
    "Liver_arteries": [-0.038252, 1.226446, 0.024375],
    "Mylohyoid": [0.000553, 1.523414, 0.047226],
    "Nasopharynx": [0.0, 1.574593, 0.006788],
    "Oral_cavity": [2.4e-05, 1.529396, 0.013551],
    "Palatoglossus": [0.000543, 1.552512, 0.040017],
    "Pancreas__Body": [0.022256, 1.19333, 0.009288],
    "Pancreas__Head": [-0.005387, 1.170743, 0.024038],
    "Pancreas_tail": [0.064625, 1.210117, -0.010502],
    "Pyloric_Sphincter_valve": [-0.017202, 1.183795, 0.047054],
    "Right_Lobe": [-0.033421, 1.232014, 0.028316],
    "Salivary_duct": [0.020385, 1.56282, 0.046411],
    "Salivary_gland": [0.0, 1.545278, 0.031475],
    "Small_Intestine": [-0.006975, 1.087169, 0.046273],
    "Stomach": [0.02741, 1.211459, 0.02635],
    "Stomach_cap": [0.024686, 1.205004, 0.044922],
    "Stomach_cap2": [0.027859, 1.24442, 0.00815],
    "Styloglossus": [0.000553, 1.545454, 0.028273],
    "Teeth_Canine_027": [-0.010193, 1.538705, 0.077558],
    "Teeth_Canine_06": [-0.01459, 1.560643, 0.077239],
    "Teeth_Canine_11": [0.014323, 1.56066, 0.077571],
    "Teeth_Canine_22": [0.009926, 1.538728, 0.07789],
    "Teeth_Incisor_central_025": [-0.002815, 1.540472, 0.08141],
    "Teeth_Incisor_central_08": [-0.002846, 1.560314, 0.08332],
    "Teeth_Incisor_central_09": [0.00258, 1.560337, 0.083652],
    "Teeth_Incisor_central_24": [0.002548, 1.540494, 0.081742],
    "Teeth_Incisor_lateral_026": [-0.007036, 1.540964, 0.079876],
    "Teeth_Incisor_lateral_07": [-0.009111, 1.559038, 0.081386],
    "Teeth_Incisor_lateral_10": [0.008844, 1.559062, 0.081718],
    "Teeth_Incisor_lateral_23": [0.006769, 1.540985, 0.080208],
    "Teeth_Molar_first_03": [-0.021315, 1.561887, 0.057246],
    "Teeth_Molar_first_14": [0.021708, 1.561194, 0.057578],
    "Teeth_Molar_first_19": [0.022395, 1.540874, 0.058079],
    "Teeth_Molar_first_30": [-0.022662, 1.540851, 0.057747],
    "Teeth_Molar_second_02": [-0.023829, 1.560474, 0.048688],
    "Teeth_Molar_second_15": [0.024407, 1.560496, 0.04902],
    "Teeth_Molar_second_18": [0.025618, 1.542657, 0.048358],
    "Teeth_Molar_second_31": [-0.025885, 1.542635, 0.048026],
    "Teeth_Molar_third_01": [-0.026654, 1.560907, 0.041569],
    "Teeth_Molar_third_16": [0.026387, 1.560932, 0.041901],
    "Teeth_Molar_third_17": [0.026524, 1.543777, 0.039584],
    "Teeth_Molar_third_32": [-0.026791, 1.543753, 0.039252],
    "Teeth_Premolar_first_05": [-0.018175, 1.561487, 0.071666],
    "Teeth_Premolar_first_12": [0.017908, 1.561563, 0.071998],
    "Teeth_Premolar_first_21": [0.015716, 1.540918, 0.072949],
    "Teeth_Premolar_first_28": [-0.016109, 1.540895, 0.072617],
    "Teeth_Premolar_second_04": [-0.021067, 1.558987, 0.065431],
    "Teeth_Premolar_second_13": [0.0208, 1.55901, 0.065763],
    "Teeth_Premolar_second_20": [0.018799, 1.541719, 0.066247],
    "Teeth_Premolar_second_29": [-0.019066, 1.541697, 0.065915],
    "Tongue": [0.00042, 1.541156, 0.044129],
  },
  respiratorysystem: {
    "Arythenoid_cartilage": [-0.000157, 1.498095, -0.000563],
    "Circothyroid_membrane_and_ligament": [0.000924, 1.491329, 0.007346],
    "Corniculate_cartilage": [-0.000158, 1.50328, 0.000226],
    "Cricoid_cartilage": [-0.000157, 1.48524, 0.005393],
    "Cuneiform_cartilage": [-0.000158, 1.504998, 0.004308],
    "Diaphragm": [0.001058, 1.234232, -0.009331],
    "Diaphragm_002": [-0.001474, 1.225238, 0.002497],
    "Digastiric": [0.000553, 1.534207, 0.017695],
    "Epiglottic_cartilage": [-0.000157, 1.511125, 0.01496],
    "Geniohyoid": [0.000553, 1.520952, 0.04859],
    "Hyoio_Bone": [0.000116, 1.519757, 0.022659],
    "Left_Bronchus": [0.058292, 1.335284, -0.019286],
    "Left_Lung": [0.058452, 1.321404, -0.01054],
    "Median_Thyrohyoid": [-0.000151, 1.508575, 0.031662],
    "Mylohyoid": [0.000553, 1.523414, 0.047226],
    "Nasal_cavity": [0.0, 1.593485, 0.062952],
    "Nasopharynx": [0.0, 1.574593, 0.006788],
    "Right_Bronchus": [-0.049171, 1.333094, -0.02319],
    "Right_Lung": [-0.050339, 1.325918, 0.000134],
    "Stylohyoid": [0.000553, 1.542648, 0.0074],
    "Stylohyoid_ligament_L": [0.021575, 1.542054, 0.010833],
    "Stylohyoid_ligament_R": [-0.020931, 1.542117, 0.010724],
    "Thyro-epiglottic_ligament": [-0.000172, 1.495992, 0.019263],
    "Thyrohyoid_membrane": [0.000226, 1.513334, 0.021673],
    "Thyrohyoid_membrane_001": [-0.000107, 1.489063, 0.00813],
    "Thyroid_cartilage": [0.000305, 1.501395, 0.009782],
    "Trachea": [-0.002009, 1.42313, -0.015932],
  },
  urinarysystem: {
    "Bladder_L": [0.007547, 0.935594, 0.005254],
    "Bladder_R": [-0.007572, 0.93554, 0.005061],
    "External urethral sphincter": [1.9e-05, 0.884371, 0.014257],
    "Kidney Back L": [0.04371, 1.17384, -0.015441],
    "Kidney Back R": [-0.051273, 1.173918, -0.013145],
    "Kidney Veins L": [0.042992, 1.182126, -0.014122],
    "Kidney Veins R": [-0.051434, 1.182418, -0.011411],
    "Kidney arteries L": [0.04307, 1.182374, -0.012379],
    "Kidney arteries R": [-0.053073, 1.182082, -0.010554],
    "Kidney front L": [0.045941, 1.175657, -0.009902],
    "Kidney front R": [-0.053869, 1.175739, -0.007496],
    "Pyramids L": [0.048608, 1.179024, -0.016164],
    "Pyramids R": [-0.056741, 1.17911, -0.013696],
    "Ureter L": [0.040715, 1.160539, -0.013366],
    "Ureter L Pelvic": [0.030978, 0.950382, -0.035232],
    "Ureter R": [-0.04748, 1.160634, -0.01054],
    "Ureter R Pelvic": [-0.028293, 0.950469, -0.032727],
    "Urethra": [-6e-06, 0.900165, 0.005133],
  },
};
